exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#slider[data-v-77976f1d] {\n  width: 16px;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n#slider[data-v-77976f1d]:hover {\n  cursor: col-resize;\n}\n#slider[data-v-77976f1d]:active {\n  cursor: ew-resize;\n}", ""]);

// exports
